<template>
  <div class="file-upload">
    <div class="file-list">
      <div
        v-for="(file, index) in value[dataKey]"
        class="file"
        :key="index"
        :class="file.isHovering && 'active'"
        @mouseenter="handleMouseenter(file)"
        @mouseleave="handleMouseLeave(file)"
      >
        <div v-show="!file.isUploading" class="file-info">
          <div class="icon">
            <i class="el-icon-document"></i>
          </div>
          <div class="file-name">{{ file.file_name }}</div>
        </div>
        <div v-show="file.isHovering && !file.isUploading" class="file-operation">
          <div
            class="copy-link"
            v-clipboard:copy="file.file_link"
            v-clipboard:success="handleCopySuccess"
            v-clipboard:error="handleCopyError"
          >
            <i class="el-icon-paperclip"></i>
          </div>
          <div class="delete" @click="handleDeleteFile(file, index, value)">
            <i class="el-icon-delete"></i>
          </div>
        </div>
        <div v-show="file.isUploading" class="upload-progress">
          <div v-if="file.percentage > 0 && file.percentage < 100" class="uploading-text">{{ $t(`${i18nPrefix}.label.uploadingText`) }}</div>
          <div v-else-if="file.percentage === 100"  class="uploading-text">{{ $t(`${i18nPrefix}.label.uploadingFinish`) }}</div>
          <el-progress class="progress" :stroke-width="Number(2)" :show-text="false" :percentage="file.percentage"></el-progress>
        </div>
      </div>
      <div class="upload">
        <div v-show="value.percentage" class="upload-progress">
          <div v-if="!value.percentage" class="uploading-text">{{ $t(`${i18nPrefix}.label.selectFileUpload`) }}</div>
        </div>
        <div v-show="!value.percentage" class="upload" @click="handleClickLinkPolicyUpload(value)">
          <div class="icon">
              <i class="el-icon-plus"></i>
          </div>
          <div class="upload-tip">{{ $t(`${i18nPrefix}.label.uploadHere`) }}</div>
          <input v-show="false" type="file" ref="uploadLinkPolicyFile" class="upload-file" @change="linkPolicyFileChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generatePolicyFileKey, getFilePath, uploadFile } from '@/utils/qiniu'
import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      required: true
    },
    dataKey: {
      required: true
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      i18nPrefix: 'admin.company.agreement'
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  methods: {
    ...mapActions('agreement', ['deleteCompanyPolicyFile']),
    handleMouseenter (file) {
      file.isHovering = true
    },
    handleMouseLeave (file) {
      file.isHovering = false
    },
    handleCopySuccess () {
      this.$message.success(this.$t(`${this.i18nPrefix}.message.copyFileUrl.success`))
    },
    handleCopyError () {
      this.$message.error(this.$t(`${this.i18nPrefix}.message.copyFileUrl.fail`))
    },
    async handleDeleteFile (file, index, policy) {
      const fileKey = generatePolicyFileKey(this.rootCompanyId, this.companyId) + `/${file.file_name}`
      const params = {
        file_key: fileKey
      }
      const resp = await this.deleteCompanyPolicyFile(params)
      if (resp) {
        this.$set(policy, 'percentage', 0)
        this.$set(policy, 'file_list', policy.file_list.splice(1, index))
      }
    },
    handleClickLinkPolicyUpload (value) {
      this.$set(value, 'percentage', 0)
      this.$refs.uploadLinkPolicyFile.dispatchEvent(new MouseEvent('click'))
    },
    async linkPolicyFileChange () {
      this.file = this.$refs.uploadLinkPolicyFile.files[0]
      if (!this.file) {
        return
      }
      this.handleBeforeUpload(this.file)
      const fileName = this.file.name
      const fileKey = generatePolicyFileKey(this.rootCompanyId, this.companyId) + `/${fileName}`
      if (this.canUpload) {
        this.value.file_list.push({
          file_name: null,
          file_link: null,
          isHovering: false,
          isUploading: true,
          percentage: 10
        })
        const index = this.value.file_list.length - 1
        const resp = await uploadFile(this.file, fileKey)
        if (resp) {
          this.fileKey = resp.key
          const filePath = getFilePath(this.fileKey)
          const file = this.value.file_list[index]
          file.file_name = fileName
          file.file_link = filePath
          file.isUploading = false
          file.percentage = 100
          this.value.file_list.splice(index, 1, file)
        }
      }
    },
    handleBeforeUpload (file) {
      if (!file) {
        this.canUpload = false
        return
      }
      const isPdf = file.type === 'application/pdf' || file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      const isLtSize = file.size / 1024 / 1024 < 10
      if (!isPdf) {
        this.canUpload = false
        this.$message({
          type: 'warning',
          message: this.$t(`${this.i18nPrefix}.message.fileTypeError`)
        })
        return
      }
      if (!isLtSize) {
        this.canUpload = false
        this.$message({
          type: 'warning',
          message: this.$t(`${this.i18nPrefix}.message.fileTypeError`)
        })
        return
      }
      this.canUpload = true
    }
  }
}
</script>

<style lang="scss" scoped>
.file-upload {
  .file-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .file {
      border: 1px solid #D9D9D9;
      border-radius: 6px;
      margin-top: 10px;
      width: 130px;
      height: 130px;
      margin-right: 16px;

      .file-info {
        .icon {
          margin-top: 30px;
          margin-left: 46px;
          margin-right: 48px;
          color: #0096CC;
          display: flex;
          font-size: 40px;
        }

        .file-name {
          font-weight: 400;
          margin-top: 13px;
          margin-bottom: 30px;
          font-size: 14px;
          text-align: center;
          color: #0096CC;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 16px;
        }
      }

      .file-operation {
        position: relative;
        bottom: 12px;
        display: flex;
        align-items: center;
        width: 106px;
        height: 106px;
        transform: translate(11%, -115%);
        transition: transform 0.3s ease 0s;
        background: rgba(0, 0, 0, 0.4);
        align-items: center;

        .copy-link {
          font-size: 22px;
          margin-right: 10px;
          margin-left: 27px;
          color: rgba(255,255,255,0.7);
          cursor: pointer;
        }

        .delete {
          font-size: 22px;
          color: rgba(255,255,255,0.7);
          cursor: pointer;
        }
      }

      .upload-progress {
        margin-top: 10px;
        margin-right: 16px;
        width: 130px;
        height: 130px;

        .uploading-text {
          margin-top: 48px;
          text-align: center;
          margin-bottom: 12px;
          color: #606266;
          font-weight: 400;
          font-size: 14px;
        }

        .progress {
          padding: 0px 12px;
        }
      }
    }
  }

  .upload {
    display: flex;

    .upload-progress {
      border: 1px dashed #0096CC;
      border-radius: 6px;
      margin-top: 10px;
      margin-right: 16px;
      width: 130px;
      height: 130px;

      .uploading-text {
        margin-top: 48px;
        text-align: center;
        margin-bottom: 12px;
        color: #606266;
        font-weight: 400;
        font-size: 14px;
      }

      .progress {
        padding: 0px 12px;
      }
    }

    .upload {
      border: 1px dashed #0096CC;
      border-radius: 6px;
      margin-top: 10px;
      display: block;
      width: 130px;
      height: 130px;
      cursor: pointer;
      background: #FAFAFA;

      .icon {
        margin-top: 42px;
        margin-left: 54px;
        color: #606266;
        font-size: 20px;
        overflow: initial;
      }

      .upload-tip {
        font-weight: 400;
        margin-top: 13px;
        margin-bottom: 43px;
        font-size: 14px;
        text-align: center;
        color: #606266;
      }
    }
  }
}
</style>
